<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="col-12">
                <div class="col-12">
                  <router-link
                    class="btn btn-sm btn-outline-dark"
                    :to="{ name: 'cxp-abono', params: {} }"
                  >
                    <i class="fas fa-angle-double-left"></i>
                    Regresar
                  </router-link>
                  <!-- aqui se empieza el menu de opciones  -->
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"> </i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"> </i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"> </i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="Imprimir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-print"> </i>
                            Imprimir Reporte
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"> </i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- aqui se termina el menu de opciones -->
                </div>
                <br />
                <div class="col-12">
                  <div class="row">
                    <div class="col-5">
                      <span class="font-weight-bold" style="font-size: 30px"
                        >CXP Abono
                      </span>
                      <span class="text-success font-weight-bold" style="font-size: 30px"
                        ># {{ current.documento }}</span
                      >
                    </div>
                    <div class="col-7">
                      <table class="table table-lightborder st-meta float-right">
                        <tbody>
                          <tr>
                            <td>
                              <label>Fecha Documento</label>
                              <input
                                :format="'dd/MM/yyyy'"
                                class="form-control form-control-sm"
                                :disabled="current.estado != 'A'"
                                type="date"
                                v-bind:class="{
                                  'is-invalid':
                                    current.errors.fecha_documento &&
                                    current.errors.fecha_documento.length > 0,
                                }"
                                v-model="current.fecha_documento"
                              />
                              <small
                                v-if="current.errors && current.errors.fecha_documento"
                                class="form-text text-danger"
                                >{{ current.errors.fecha_documento[0] }}</small
                              >
                            </td>
                            <td>
                              <label>Fecha Vencimiento</label>
                              <input
                                type="date"
                                :format="'dd/MM/yyyy'"
                                class="form-control form-control-sm"
                                :disabled="current.estado != 'A'"
                                v-bind:class="{
                                  'is-invalid':
                                    current.errors.fecha_vencimiento &&
                                    current.errors.fecha_vencimiento.length > 0,
                                }"
                                v-model="current.fecha_vencimiento"
                              />
                              <small
                                v-if="current.errors && current.errors.fecha_vencimiento"
                                class="form-text text-danger"
                                >{{ current.errors.fecha_vencimiento[0] }}</small
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <form @submit="guardar">
                <br />
                <br />
                <div class="row">
                  <div class="col-9 row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.tipo_abono &&
                              current.errors.tipo_abono.length > 0,
                          }"
                          >Tipo Abono</label
                        >
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.tipo_abono"
                          :disabled="current.estado != 'A'"
                          @change="refreshAbonoSeries"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option v-for="(c, key) in tipoabono" :value="c.id" :key="key">
                            {{ c.nombre }}
                          </option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tipo_abono"
                          class="form-text text-danger"
                          >{{ current.errors.tipo_abono[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger': current.detail && current.detail.length > 0,
                          }"
                          >Serie de Abono</label
                        >
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.abono_serie"
                          :disabled="current.estado != 'A'"
                          @change="changeAbonoSerie"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="c in abonoseries"
                            :value="c.serie"
                            :key="c.serie"
                          >
                            {{ c.serie }}
                          </option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.detail"
                          class="form-text text-danger"
                          >{{ current.errors.detail[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.documento &&
                              current.errors.documento.length > 0,
                          }"
                          >Documento
                        </label>
                        <input
                          v-model="current.documento"
                          class="form-control"
                          placeholder="Documento"
                          :disabled="
                            current.estado != 'A' ||
                            current.abono_serie_obj.correlativo_automatico
                          "
                          v-bind:class="{
                            'is-invalid':
                              current.errors.documento &&
                              current.errors.documento.length > 0,
                          }"
                          type="text"
                        />
                        <small
                          v-if="current.errors && current.errors.documento"
                          class="form-text text-danger"
                          >{{ current.errors.documento[0] }}</small
                        >
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.cuenta_bancaria &&
                              current.errors.cuenta_bancaria.length > 0,
                          }"
                          >Cuenta Bancaria</label
                        >
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.cuenta_bancaria"
                          :disabled="current.estado != 'A'"
                          @change="refreshCuentaBancaria"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in cuentabancaria"
                            :value="c.id"
                            :key="key"
                          >
                            {{ c.id }} - {{ c.nombre }}
                          </option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.cuenta_bancaria"
                          class="form-text text-danger"
                          >{{ current.errors.cuenta_bancaria[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-8">
                      <ProveedoresSelectComponent
                        :current="current"
                        @onChange="onChangeProveedor"
                        :disabled="current.estado != 'A'"
                      />
                    </div>

                    <div class="col-5">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.beneficiario &&
                              current.errors.beneficiario.length > 0,
                          }"
                          >Beneficiario</label
                        >
                        <input
                          v-model="current.beneficiario"
                          class="form-control"
                          placeholder="Beneficiario"
                          :disabled="current.estado != 'A'"
                          v-bind:class="{
                            'is-invalid':
                              current.errors.beneficiario &&
                              current.errors.beneficiario.length > 0,
                          }"
                          type="text"
                        />
                        <small
                          v-if="current.errors && current.errors.beneficiario"
                          class="form-text text-danger"
                          >{{ current.errors.beneficiario[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.descripcion &&
                              current.errors.descripcion.length > 0,
                          }"
                          >Observaciones</label
                        >
                        <textarea
                          v-model="current.descripcion"
                          class="form-control"
                          placeholder="Observaciones"
                          :disabled="current.estado != 'A'"
                          rows="2"
                          v-bind:class="{
                            'is-invalid':
                              current.errors.descripcion &&
                              current.errors.descripcion.length > 0,
                          }"
                          type="text"
                        >
                        </textarea>
                        <small
                          v-if="current.errors && current.errors.descripcion"
                          class="form-text text-danger"
                          >{{ current.errors.descripcion[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-2">
                      <h6>¿Negociable?</h6>
                      <div class="col-md-12">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              name="optionsRadios1"
                              v-model="current.es_negociable"
                              type="radio"
                              :disabled="current.estado != 'A'"
                              value="true"
                            />
                            Si
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.es_negociable"
                              name="optionsRadios1"
                              :disabled="current.estado != 'A'"
                              type="radio"
                              value="false"
                            />No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <!--------------------START - PANEl -------------------->
                    <div style="padding: 15px" class="panel panel-hover">
                      <div
                        style="padding: 5px"
                        class="badge col-12"
                        :class="{
                          'badge-primary': current.estado == 'A',
                          'badge-warning': current.estado == 'B',
                          'badge-danger': current.estado == '9',
                        }"
                      >
                        <i class="os-icon os-icon-ui-09"></i>
                        <span class="text-uppercase" v-if="current.estado_str">
                          Estatus {{ current.estado_str }}</span
                        >
                        <span v-if="!current.estado_str">En Proceso</span>
                      </div>

                      <h6 style="font-size: 15px" class="text-center">
                        <br />
                        <i class="fas fa-exchange-alt"></i>
                        &nbsp;&nbsp;&nbsp;&nbsp;TOTALES
                      </h6>
                      <div class="row">
                        <small
                          v-if="current.errors && current.errors.fecha_conciliacion"
                          class="form-text text-danger"
                          >{{ current.errors.fecha_conciliacion[0] }}</small
                        >
                        <br />
                        <div class="col-12">
                          <label>MONTO DEL ABONO</label>
                          <div class="input-group input-group-md">
                            <div class="input-group-prepend">
                              <div
                                style="background-color: #9ad473"
                                class="input-group-text"
                              >
                                Q
                              </div>
                            </div>
                            <input
                              class="form-control form-control-sm text-right"
                              style="font-size: 17px; height: 30px"
                              :disabled="current.estado != 'A'"
                              @input="formatNumber()"
                              v-model="current.valor"
                              placeholder="Precio"
                              type="text"
                            />
                            <small
                              v-if="current.errors && current.errors.valor"
                              class="form-text text-danger"
                              >{{ current.errors.valor[0] }}</small
                            >
                          </div>
                        </div>
                        <div class="col-12">
                          <label>APLICADO EN CARGOS</label>
                          <div class="input-group input-group-md">
                            <div class="input-group-prepend">
                              <div
                                style="background-color: #9ad473"
                                class="input-group-text"
                              >
                                Q
                              </div>
                            </div>
                            <input
                              class="form-control form-control-sm text-right"
                              style="font-size: 17px; height: 30px"
                              :disabled="true"
                              v-model="current.total_aplicado"
                              placeholder="Precio"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <label>SALDO DISPONIBLE</label>
                          <div class="input-group input-group-md">
                            <div class="input-group-prepend">
                              <div
                                style="background-color: #9ad473"
                                class="input-group-text"
                              >
                                Q
                              </div>
                            </div>
                            <input
                              class="form-control form-control-sm text-right"
                              style="font-size: 17px; height: 30px"
                              :disabled="true"
                              v-model="current.total_pendiente"
                              placeholder="Precio"
                              type="text"
                            />
                          </div>
                        </div>
                        <!-- <div class="col-12">
                              <h6>Estatus Contable</h6>
                              <div class="col-sm-12">
                                <div class="form-check">
                                  <label class="form-check-label">
                                    <input
                                      checked
                                      class="form-check-input"
                                      name="optionsRadios"
                                      v-model="current.estatus_contab"
                                      type="radio"
                                      :disabled="true"
                                      value="true"
                                    />Contabilizado
                                  </label>
                                </div>
                                <div class="form-check">
                                  <label class="form-check-label">
                                    <input
                                      class="form-check-input"
                                      v-model="current.estatus_contab"
                                      name="optionsRadios"
                                      :disabled="true"
                                      type="radio"
                                      value="false"
                                    />Sin Contabilizar
                                  </label>
                                </div>
                              </div>
                            </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-2">
                  <button
                    class="btn btn-primary btn-block"
                    type="submit"
                    :disabled="current.estado != 'A'"
                  >
                    <i class="fas fa-save"></i> Guardar
                  </button>
                </div>
              </form>
              <br />
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    >Contabilización</a
                  >
                  <a
                    v-if="current.id"
                    class="nav-item nav-link"
                    id="abonados-tab"
                    data-toggle="tab"
                    href="#abonados"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Documentos Abonados</a
                  >
                </div>
              </nav>
              <div class="tab-content pt-2" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div>
                    <div class="row">
                      <br />
                      <h6 class="text-success">Lista de contabilización</h6>
                      <div class="col-2">
                        <button
                          :disabled="!current.id || current.estado != 'A'"
                          data-target="#AggModalContabilizacion"
                          data-toggle="modal"
                          href="#"
                          class="btn btn-md btn-primary"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <AggContabilizacionComponent
                      @refreshCargo="refreshCurrent()"
                      :current_="current"
                    />
                    <div class="table-responsive">
                      <br />
                      <!-------------------- Tabla de REsultados -------------------->
                      <table class="table table-lightborder">
                        <thead>
                          <tr>
                            <th class="text-left">Cuenta Contable</th>
                            <th class="text-left">Centro Costo</th>
                            <th class="text-left">Fecha</th>
                            <th class="text-right">Cargo</th>
                            <th class="text-right">Abono</th>
                            <th class="text-center">Opciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="detalle in current.abonocontab_set"
                            v-bind:key="detalle.id"
                          >
                            <td>
                              {{ detalle.cuenta_contable }} -
                              {{ detalle.cuenta_contable_obj.nombre }}
                            </td>
                            <td class="text-left">
                              {{ detalle.centro_costo }} -
                              {{ detalle.centro_costo_obj.nombre }}
                            </td>
                            <td class="text-left">{{ detalle.fecha }}</td>
                            <td class="text-right">Q{{ detalle.cargo }}</td>
                            <td class="text-right">Q{{ detalle.abono }}</td>
                            <td class="text-center">
                              <button
                                :disabled="current.estado != 'A'"
                                @click="eliminarContabilicacion(detalle)"
                                class="btn btn-sm btn-danger"
                              >
                                <i class="fa fa-trash-alt"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot style="background-color: #454545" class="text-light">
                          <tr>
                            <td class="font-weight-bold" colspan="3">
                              <h6 class="text-light">TOTALES</h6>
                            </td>
                            <td class="text-right">
                              <span style="font-size: 15px" class="font-weight-bold"
                                >CARGO Q{{ current.total_contab_cargo }}</span
                              >
                            </td>
                            <td class="text-right font-weight-bold">
                              <span style="font-size: 15px"
                                >ABONO Q{{ current.total_contab_abono }}</span
                              >
                            </td>
                            <td colspan="4"></td>
                          </tr>
                        </tfoot>
                      </table>
                      <!-------------------- END - Basic Table -------------------->
                    </div>
                  </div>
                </div>
                <div
                  v-if="current.id"
                  class="tab-pane fade"
                  id="abonados"
                  role="tabpanel"
                  aria-labelledby="abonados-tab"
                >
                  <h6 class="text-success">Lista de Abonos Realizados</h6>
                  <AbonoAplicacionCargoComponent
                    :current="current"
                    @refresh="refreshCurrent"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import AbonoService from "@/services/cxp/AbonoService";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import AbonoAplicacionCargoComponent from "@/components/cxp/abono/AbonoAplicacionCargoComponent";
import AggContabilizacionComponent from "@/components/cxp/abono/AggContabilizacionComponent";

export default {
  watch: {
    current: {
      handler: function (newValue) {
        this.current.valor = newValue.valor
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.current.total_aplicado = newValue.total_aplicado
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.current.total_pendiente = newValue.total_pendiente
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      deep: true,
    },
  },
  components: {
    ProveedoresSelectComponent,
    AbonoAplicacionCargoComponent,
    AggContabilizacionComponent,
  },
  data() {
    return {
      current: {
        id: null,
        valor_temp: 0,
        estado_str: null,
        total_aplicado: 0,
        total_pendiente: 0,
        documento_obj: null,
        documento: null,
        fecha_creacion: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        valor: 0,
        descripcion: null,
        estatus_contab: false,
        conciliado: false,
        fecha_conciliacion: null,
        estado: "A",
        beneficiario: null,
        es_negociable: false,
        tipo_abono: null,
        abono_serie: null,
        proveedor: null,
        aplicacionabonocargo_set: [],
        cuenta_bancaria: null,
        abono_serie_obj: {
          correlativo_automatico: false,
        },
        errors: {
          id: null,
          estado_str: null,
          total_aplicado: null,
          total_pendiente: null,
          documento: null,
          fecha_creacion: null,
          fecha_documento: null,
          fecha_vencimiento: null,
          valor: null,
          descripcion: null,
          estatus_contab: null,
          conciliado: null,
          fecha_conciliacion: null,
          estado: null,
          beneficiario: null,
          es_negociable: null,
          tipo_abono: null,
          abono_serie: null,
          proveedor: null,
          cuenta_bancaria: null,
        },
      },
      errors: {
        id: null,
        estado_str: null,
        total_aplicado: null,
        total_pendiente: null,
        documento: null,
        fecha_creacion: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        valor: null,
        descripcion: null,
        estatus_contab: null,
        conciliado: null,
        fecha_conciliacion: null,
        estado: null,
        beneficiario: null,
        es_negociable: null,
        tipo_abono: null,
        abono_serie: null,
        proveedor: null,
        cuenta_bancaria: null,
      },
      abonoseries: [],
      tipoabono: [],
    };
  },
  computed: {
    ...mapGetters({
      fecha_actual: "commons/fecha_actual",
      proveedor: "catalogos/proveedores",
      cuentabancaria: "catalogos/cuentas",
    }),
  },
  mounted() {
    let self = this;

    if (self.$route.params.id) {
      self.refreshCurrent();
    } else {
      self.$store.dispatch("commons/fecha_actual").then((response) => {
        self.current.fecha_documento = self.fecha_actual;
        self.current.fecha_vencimiento = self.current.fecha_documento;

        self.current.fecha_documento = self.customFormatterInverted(
          self.current.fecha_documento
        );
        self.current.fecha_vencimiento = self.customFormatterInverted(
          self.current.fecha_vencimiento
        );
      });
    }
    self.refreshCurrent();
    self.refreshTipoAbono();
    self.refreshProveedor();
    self.refreshCuentaBancaria();
  },
  methods: {
    formatNumber() {
      if (!this.current.valor) {
        return;
      }
      this.current.valor = this.current.valor.toString().replace(/,/g, "");
      if (this.current.valor.includes(".")) {
        this.current.valor = this.current.valor.replace(/\./g, "");
        this.current.valor = this.current.valor.toString().replace(/(\d{2})$/, ".$1");
      }
      this.current.valor = this.current.valor
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    eliminarContabilicacion(det) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Contabilización",
        "¿Está seguro?",
        "",
        function () {
          DynamicService.postAction(
            "cxp",
            "abonos",
            self.current.id,
            "eliminar_contabilizacion",
            det
          )
            .then((response) => {
              Notifications.alert.success(
                "Eliminar Contabilización",
                "Realizado Exitosamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              Notifications.alert.error(
                "Eliminar Contabilización",
                errors.response.data.detail
              );
            });
        }
      );
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add("days").format("YYYY-MM-DD");
    },
    refreshCurrent() {
      let self = this;
      if (this.$route.params.id) {
        AbonoService.getById(this.$route.params.id).then((response) => {
          self.current = Object.assign(self.current, response.data);
          self.current.proveedor = self.current.proveedor_obj;
          self.current.valor_temp = self.current.valor;
          self.current.fecha_documento = self.customFormatterInverted(
            self.current.fecha_documento
          );
          self.current.fecha_vencimiento = self.customFormatterInverted(
            self.current.fecha_vencimiento
          );
          self.current.fecha_conciliacion = self.customFormatterInverted(
            self.current.fecha_conciliacion
          );
        });
      }
    },
    refreshTipoAbono() {
      let self = this;
      DynamicService.fetch("cxp", "tipo-abono", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tipoabono = res.data;
        if (self.tipoabono.length != 0) {
          self.current.tipo_abono = self.tipoabono[0].id;
          self.refreshAbonoSeries();
        }
      });
    },
    refreshAbonoSeries() {
      let self = this;
      DynamicService.fetch("cxp", "abono-serie", {
        activa: true,
        tipo_abono: self.current.tipo_abono,
        quitar_paginacion: true,
      }).then((res) => {
        self.abonoseries = res.data;
        if (self.abonoseries.length != 0) {
          self.current.abono_serie = self.abonoseries[0].serie;
          self.changeAbonoSerie();
        }
      });
    },
    changeAbonoSerie() {
      let self = this;
      let obj = self.abonoseries.filter(function (elem) {
        if (elem.serie == self.current.abono_serie) return elem;
      });
      if (obj.length == 1) {
        self.current.abono_serie_obj = obj[0];
      }
    },
    refreshProveedor() {
      let self = this;
      self.$store.dispatch("catalogos/proveedores", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshCuentaBancaria() {
      let self = this;
      self.$store.dispatch("catalogos/cuentas", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      self.current.errors = [];
      var current = Object.assign({}, self.current);
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
      }
      if (current.proveedor) {
        current.proveedor = current.proveedor.codigo;
      }
      if (current.id == null && current.abono_serie_obj.correlativo_automatico) {
        current.documento = 0;
      }
      if (current.fecha_documento) {
        current.fecha_documento = moment(current.fecha_documento).format("DD/MM/YYYY");
      }
      if (current.fecha_vencimiento) {
        current.fecha_vencimiento = moment(current.fecha_vencimiento).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_conciliacion) {
        current.fecha_conciliacion = moment(current.fecha_conciliacion).format(
          "DD/MM/YYYY"
        );
      }
      if (current.valor) {
        current.valor = current.valor.replace(/,/g, "");
      }
      console.log(current);
      AbonoService.save(current)
        .then((res) => {
          Notifications.alert.success("Abono", "Se ha guardado la Información.");
          self.$router.push({
            name: "cxp-abono-editar",
            params: { id: res.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          AbonoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },

    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          AbonoService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success("Abonos", "Se ha cerrado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          AbonoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success("Abonos", "Se ha anulado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    Imprimir() {
      let op;
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxp/abono/cxp_abono_report.jrxml&id=${op}`
      );
    },
    onChangeProveedor(prv) {
      let self = this;
      self.current.beneficiario = prv.nombre;
    },
  },
};
</script>
